export default __webpack_public_path__ + "static/media/work_img6.834ff62a.jpg";